import { z } from 'zod';
import { IdSchema, ListQuerySchema, PageInfoSchema, TimestampSchema } from './common.js';
export const AuditEventSchema = z.strictObject({
    id: IdSchema,
    organizationId: IdSchema,
    actorIdentityId: IdSchema.nullable(),
    actorDisplayName: z.string().nullable(),
    action: z.string(),
    targetType: z.string(),
    targetId: IdSchema.nullable(),
    requestId: z.string().nullable(),
    metadata: z.record(z.string(), z.unknown()),
    createdAt: TimestampSchema,
});
/** Audit history for one record: both filters together, or neither. */
export const AuditEventListQuerySchema = ListQuerySchema.extend({
    targetType: z
        .string()
        .trim()
        .regex(/^[a-z_]{1,100}$/)
        .optional(),
    targetId: IdSchema.optional(),
}).refine((query) => (query.targetType === undefined) === (query.targetId === undefined), {
    message: 'targetType and targetId must be provided together',
    path: ['targetId'],
});
export const AuditEventListSchema = z.strictObject({
    items: z.array(AuditEventSchema),
    page: PageInfoSchema,
});
